<template>
  <div class="visualizations">
    <base-section-heading title="Visualizzazioni">
      Rappresentazioni grafiche interattive dei dati raccolti nell'Edizione Nazionale Digitale delle Opere di Aldo Moro.
    </base-section-heading>

    <BubbleChart />
  </div>
</template>

<script>
import BubbleChart from "@/components/visualizations/BubbleChart.vue";

export default {
  components: { BubbleChart }
};
</script>
